var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-shop-view"},[_c('div',{staticClass:"shop-item"},[_c('welfare')],1),_vm._v(" "),_c('div',{staticClass:"shop-item"},[_c('rebate')],1),_vm._v(" "),_c('div',{staticClass:"shop-item"},[_c('expack')],1),_vm._v(" "),_c('div',{staticClass:"shop-item"},[_c('vippack')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ade2edc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop.vue
// module id = null
// module chunks = 